import VStack from "@/components/Layout/VStack";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import GroupIdBreadcrumb from "./_$id/-components/Header/GroupIdBreadcrumb";
import GroupIdHeader from "./_$id/-components/Header/GroupIdHeader";
import GroupIdHeaderTabs from "./_$id/-components/Header/GroupIdHeaderTabs";

export const Route = createFileRoute(
  "/_staff/id-managements/group-id/$id/_$id",
)({
  component: Layout,
});

export default function Layout() {
  return (
    <VStack>
      <VStack className="gap-4 bg-background px-12 pt-4 shadow-sm">
        <GroupIdBreadcrumb />
        <GroupIdHeader />
        <GroupIdHeaderTabs />
      </VStack>
      <Outlet />
    </VStack>
  );
}
